// Styles
import './discover-recipes.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initDiscoverRecipes = (context) => {
  const discoverRecipesSection = context.closest('.shopify-section');
  if (!discoverRecipesSection) return;

  const swiperContainer = discoverRecipesSection.querySelector('.discover-recipes__articles-wrapper');
  if (swiperContainer && swiperContainer.querySelectorAll('.swiper-slide').length > 0) {
    new Swiper(swiperContainer, {
      loop: false,
      slidesPerView: 1,
      pagination: {
        el: swiperContainer.querySelector('.discover-recipes__articles-pagination'),
        clickable: true
      },
      breakpoints: {
        751: {
          slidesPerView: 3
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.discover-recipes__container'), (el) => {
    window.dAgency.initDiscoverRecipes(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.discover-recipes__container'), (el) => {
      window.dAgency.initDiscoverRecipes(el);
    });
  });
}
